import { isMobile } from '../services/mql-service';
import { dynamicGrid } from '../services/dynamic-grid-service';

export class LocationsLandingLocationTypes extends DrupalBehavior {
  onContent(context) {
    const grids = document.querySelectorAll('.location-types--grid');
    grids.forEach((grid) => {
      const items = grid.querySelectorAll('.locations-landing--location-type');
      let numColumns;

      if (isMobile()) {
        numColumns = 1;
      } else {
        numColumns = 3;
      }

      dynamicGrid(items, numColumns);
    });
  }
}

DrupalBehavior.register(
  'rush_theme.blocks',
  'locations_landing_location_types',
  LocationsLandingLocationTypes
);
